export default "__VITE_ASSET__ac00b8ca__"